import { render, staticRenderFns } from "./BranchRemGoods.vue?vue&type=template&id=79f540aa"
import script from "./BranchRemGoods.vue?vue&type=script&lang=js"
export * from "./BranchRemGoods.vue?vue&type=script&lang=js"
import style0 from "./BranchRemGoods.vue?vue&type=style&index=0&id=79f540aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports